import { RegexValidators } from '@libs/validations';
export const isValidEmail = (email) => RegexValidators.IS_EMAIL_VALID.test(email);
//# sourceMappingURL=email.js.map